import isValidEmailAddress from './isValidEmailAddress';
import formatPhoneNumber, { Styles } from './formatPhoneNumber';

export default function formatContactValue(value: string, phoneStyle?: Styles) {
  if (isValidEmailAddress(value)) return value;
  return formatPhoneNumber(value, phoneStyle);
}
